<template>
    <div>
        <Gl_leftmenu />
        <Gl_header />
        <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
        <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
        <div class="content">
            <div class="content-header">
                <Backbutton />
                Загрузка документов (Презентация и решение)
            </div><br>
            <p>
                В данном меню Вы можете загрузить документы для конкурсного отбора.<br>
                Внимание! При загрузке для файлов сохраняется дата и время
            </p>
            <div class="header-for-input"><pre>Презентация: <a v-show="file_to_api_path(uploaded.presentation.path_file).is_uploaded" :href="file_to_api_path(uploaded.presentation.path_file).file_src">Просмотреть загруженный файл</a></pre></div>
            <input type="file" ref="presentation" @change="upload_file_presentation()" />

            <div class="header-for-input"><pre>Видеоролик: <a v-show="file_to_api_path(uploaded.video.path_file).is_uploaded" :href="file_to_api_path(uploaded.video.path_file).file_src">Просмотреть загруженный файл</a></pre></div>
            <input type="file" ref="video" @change="upload_file_video()" />

            <div class="header-for-input"><pre>Решение кейса: <a v-show="file_to_api_path(uploaded.solvedcase.path_file).is_uploaded" :href="file_to_api_path(uploaded.solvedcase.path_file).file_src">Просмотреть загруженный файл</a></pre></div>
            <input type="file" ref="solvedcase" @change="upload_file_solvedcase()" />

            <div class="header-for-input"><pre>Официальное письмо: <a v-show="file_to_api_path(uploaded.oficialmail.path_file).is_uploaded" :href="file_to_api_path(uploaded.oficialmail.path_file).file_src">Просмотреть загруженный файл</a></pre></div>
            <input type="file" ref="oficialmail" @change="upload_file_oficialmail()" />
        </div>
    </div>
</template>

<script>

import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'
import Backbutton from '@/components/elements/bacl-button.vue'

export default {
    name: 'UploadKcop',
    components: {
        Success, Error, Backbutton
    },
    props: {
        id: String
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            kcop: {
                company_id: 0
            },
            uploaded: {
                presentation: {
                    is_uploaded: false,
                    file_src: process.env.VUE_APP_API_URL,
                },
                video: {
                    is_uploaded: false,
                    file_src: process.env.VUE_APP_API_URL,
                },
                solvedcase: {
                    is_uploaded: false,
                    file_src: process.env.VUE_APP_API_URL,
                },
                oficialmail: {
                    is_uploaded: false,
                    file_src: process.env.VUE_APP_API_URL,
                }

            },
            companies: {}

        }
    },
    methods: {
        file_to_api_path(file_name) {
            if((file_name != null)&&(file_name != '')) 
                return {
                    is_uploaded: true,
                    file_src: process.env.VUE_APP_API_URL+'/storage/'+file_name,
                }
            else
                return {
                    is_uploaded: false,
                    file_src: process.env.VUE_APP_API_URL,
                }
                    
        },
        upload_file_presentation() {
            let formdata = new FormData()
            formdata.append('file', this.$refs.presentation.files[0])
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
            this.axios.post(process.env.VUE_APP_API_URL + '/api/kcop/upload/'+this.id+'/presentation', formdata)
            .then(response => {
              loader.hide()
                console.log(response.data.data)
                //this.get_uploaded_file()
                this.get_uploaded()

            })
            .catch(error => {
                loader.hide();
                 this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        },
        upload_file_video() {
            let formdata = new FormData()
            formdata.append('file', this.$refs.video.files[0])
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
            this.axios.post(process.env.VUE_APP_API_URL + '/api/kcop/upload/'+this.id+'/video', formdata)
            .then(response => {
              loader.hide()
                console.log(response.data.data)
                //this.get_uploaded_file()
                this.get_uploaded()

            })
            .catch(error => {
                loader.hide();
                 this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        },
        upload_file_solvedcase() {
            let formdata = new FormData()
            formdata.append('file', this.$refs.solvedcase.files[0])
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
            this.axios.post(process.env.VUE_APP_API_URL + '/api/kcop/upload/'+this.id+'/solvedcase', formdata)
            .then(response => {
              loader.hide()
                console.log(response.data.data)
                this.get_uploaded()

            })
            .catch(error => {
                loader.hide();
                 this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        },
        upload_file_oficialmail() {
            let formdata = new FormData()
            formdata.append('file', this.$refs.oficialmail.files[0])
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
            this.axios.post(process.env.VUE_APP_API_URL + '/api/kcop/upload/'+this.id+'/oficialmail', formdata)
            .then(response => {
              loader.hide()
                console.log(response.data.data)
                this.get_uploaded()

            })
            .catch(error => {
                loader.hide();
                 this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        },
        get_uploaded() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
            this.axios.get(process.env.VUE_APP_API_URL + '/api/kcop/uploaded/'+this.id)
            .then(response => {
              loader.hide()
                console.log(response.data.data)
                //this.get_uploaded_file()
                this.uploaded = response.data.data

            })
            .catch(error => {
                loader.hide();
                 this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        },
        //oficialmail
    },
    created() {
        this.get_uploaded()
    }
}

</script>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>